"use client";

import { useTranslations } from "next-intl";
import { Box, Image, Stack, Typography, useMediaQuery, useTheme } from "@/components/controls/base-controls";
import { FaInstagram, FaLinkedin } from "@/components/controls/icons";
import { WEBPAGE_CORE_CONTAINER } from "@/core/constants/webpages";
import { Link } from "@/i18n/navigation";

const MainFooter = () => {
	const t = useTranslations();

	const theme = useTheme();
    // Returns true if screen width is 'sm' (default 600px) or smaller
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<Box
			sx={{
				backgroundColor: "var(--mui-palette-darkest)",
				width: "100%"
			}}
		>
			<Stack
				sx={{
					margin: "0 auto",
					width: WEBPAGE_CORE_CONTAINER,
					maxWidth: "100%",
					display: "grid",
					padding: {xs: "2em 1em 3em", md: "4em 1em 5em"},
					gridTemplateColumns: "1fr 1fr",
					columnGap: 4
				}}
			>
				<Box
					sx={{
						display: "flex",
						flexDirection: "column",
						justifyContent: "flex-start",
						alignItems: "flex-end",
					}}
				>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
							alignItems: "center",
							gap: ".25em",
						}}
					>
						<Image
							src="/images/logo_sw.png"
							alt="Navairra Logo"
							loading="eager"
							width={isMobile ? 44 : 66}
							height={isMobile ? 31 : 47}
						/>
						<Typography
							variant="companyName"
							sx={{ color: "var(--mui-palette-lightest)" }}
						>
							{t("company.name")}
						</Typography>

						<Typography
							variant="tagLine"
							sx={{
								color: "var(--mui-palette-lightest)",
								letterSpacing: "3px",
							}}
						>
							{t("company.slogan")}
						</Typography>
					</Box>				

				</Box>

				<Box sx={{
					display: "flex",
					justifyContent: "flex-start",
					paddingLeft: {xs: 0, md: "2.5em"},
					width: "100%"
				}}
				>
					<Stack sx={{
							direction: "column",
							alignItems: "flex-start",
							justifyContent: "flex-start",
							width: "content",
							rowGap: 1
						}}
					>
						<Box sx={{display: "flex", columnGap: 1.5 }}>
							<FaInstagram color="white" />
							<FaLinkedin  color="white"/>
						</Box>
				
						<Typography variant="footer">
							<Link
								href="https://www.navairra.com/contact"
								style={{
									whiteSpace: "pre-line",
									color: "var(--mui-palette-link-highlight)",
								}}
							>
								{t("footer.careers")}
							</Link>

							<Link
								href="https://www.navairra.com/contact"
								style={{
									whiteSpace: "pre-line",
									color: "var(--mui-palette-link-highlight)",
									marginLeft: "1em",
								}}
							>
								{t("footer.contact")}
							</Link>
						</Typography>

						<Typography variant="footer">
							<Link
								href="https://www.navairra.com/terms"
								style={{
									whiteSpace: "pre-line",
									color: "var(--mui-palette-link-highlight)",
								}}
							>
								{t("footer.terms")}
							</Link>

							<Link
								href="https://www.navairra.com/privacy"
								style={{
									whiteSpace: "pre-line",
									color: "var(--mui-palette-link-highlight)",
									marginLeft: "1em",
								}}
							>
								{t("footer.privacy")}
							</Link>
						</Typography>

						<Typography
							variant="footer"
							sx={{ color: "var(--mui-palette-lightest)" }}
						>
							{t("footer.copyright")}
						</Typography>

					</Stack>
				</Box>
			</Stack>
		</Box>
	);
};

export default MainFooter;
